import type { ReactNode } from 'react'
import { motion } from 'framer-motion'

export type BetDockProps = {
  parameterSlot?: ReactNode
  amountSlot?: ReactNode
  ctaSlot?: ReactNode
  metaSlot?: ReactNode
  error?: string | null
  className?: string
}

export function BetDock({
  parameterSlot,
  amountSlot,
  ctaSlot,
  metaSlot,
  error,
  className = '',
}: BetDockProps) {
  return (
    <div className={`bet-dock-container ${className}`}>
      {parameterSlot && <div className="bet-dock-tier-params">{parameterSlot}</div>}
      {amountSlot && <div className="bet-dock-tier-amount">{amountSlot}</div>}
      {ctaSlot && <div className="bet-dock-tier-cta">{ctaSlot}</div>}
      <div
        className="bet-dock-error-slot"
        aria-atomic="true"
      >
        {error && (
          <motion.p
            className="bet-dock-error"
            role="alert"
            aria-live="assertive"
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {error}
          </motion.p>
        )}
      </div>
      {metaSlot && <div className="bet-dock-meta-info">{metaSlot}</div>}
    </div>
  )
}
